module.exports = __webpack_public_path__ + "static/media/house-min.6b458bcf.jpg";